import { ChangeDetectionStrategy, Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ActionPreviewInfoBlockSection } from '../../../../../services/gable/gable.service';
import { ActionPreviewFact, infoBlockFacts } from '../action-preview-diff';

/**
 * Generic `info_block` section — a tinted panel with a free-form body.
 * Also serves as the forward-compat fallback when the host card hits an
 * unknown section kind it doesn't recognize.
 */
@Component({
    selector: 'app-ap-info-block-section',
    templateUrl: './info-block-section.component.html',
    styleUrls: ['./info-block-section.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ActionPreviewInfoBlockSectionComponent {
    @Input({ required: true }) section!: ActionPreviewInfoBlockSection;

    /** A long list body (173 units to charge) opens collapsed, like a long table. */
    static readonly COLLAPSE_OVER = 10;
    static readonly PREVIEW_LINES = 5;

    showAll = false;

    get lines(): string[] {
        return (this.section.body ?? '').split('\n');
    }

    /** A short body made only of "Label: value" lines reads as plain fact rows; null keeps the alert. */
    get facts(): ActionPreviewFact[] | null {
        if (this.section.tone === 'warning' || this.collapsible) {
            return null;
        }
        const filled = this.lines.filter((line) => line.trim() !== '');
        const facts = infoBlockFacts(this.section.body);
        return facts.length > 0 && facts.length === filled.length ? facts : null;
    }

    get collapsible(): boolean {
        return this.lines.length > ActionPreviewInfoBlockSectionComponent.COLLAPSE_OVER;
    }

    get shownBody(): string {
        return this.collapsible && !this.showAll
            ? this.lines.slice(0, ActionPreviewInfoBlockSectionComponent.PREVIEW_LINES).join('\n')
            : this.section.body;
    }
}
